import { apiPost, apiPostVoid } from "@/core/api";

export interface CreateApplicationRequest {
    citizenId: string;
    idempotencyToken: string;

    isForReplacementCard: boolean;
}

export const submitApplication = (req: CreateApplicationRequest) => {
    return apiPost<string>("applications/socialSecurity/online", req);
}

export enum ApplicationEvent {
    FORWARDED_FOR_NEW_CARD = "FORWARDED_FOR_NEW_CARD",
    FORWARDED_FOR_REPLACEMENT_CARD = "FORWARDED_FOR_REPLACEMENT_CARD",
    FORWARDED_FOR_LOGIN = "FORWARDED_FOR_LOGIN",
    APPLICATION_NOT_SUBMITTED = "APPLICATION_NOT_SUBMITTED",
    APPLICATION_SUBMITTED = "APPLICATION_SUBMITTED",
    APPLICATION_APPROVED = "APPLICATION_APPROVED",
    APPLICATION_REJECTED = "APPLICATION_REJECTED",
    REAPPLY = "REAPPLY",
}

export const submitApplicationEvent = (applicationId: string, event: ApplicationEvent) => {
    return apiPostVoid(`applications/socialSecurity/${applicationId}/events`, event);
}